// Simple matching engine for demo: matches by amount and reference number
export function getMatchSuggestions(transaction, invoices, reimbursements) {
  const suggestions = [];
  if (transaction.amount > 0) {
    // Try to match to invoices
    invoices.forEach(inv => {
     // console.log('Matching transaction', transaction.id, 'amount', transaction.amount, 'to invoice', inv.id, 'amount', inv.total || inv.grandTotal);
      if ( Math.abs(Number(inv.total || inv.grandTotal) - Math.abs(transaction.amount)) < 0.01) {
        suggestions.push({
          id: inv.id,
           entityType: 'INVOICE',
          entityId: inv.invoiceOrQuoteNumber,
          matchReason: 'Exact amount match',
          data: inv,
        });
      } else if (inv.referenceNumber && inv.referenceNumber === transaction.referenceNumber) {
        suggestions.push({
          id: inv.id,
          entityType: 'INVOICE',
          entityId: inv.invoiceOrQuoteNumber,
          matchReason: 'Reference number match',
          data: inv,
        });
      }
    });
  } else if (transaction.amount < 0) {
    // Try to match to reimbursements
    reimbursements.forEach(exp => {
      if ( Math.abs(Number(exp.claimedAmount || exp.amount) - Math.abs(transaction.amount)) < 0.01) {
        suggestions.push({
          id: exp.id,
         entityType: 'EXPENSE',
          entityId: exp.referenceNumber || exp.reimbursementNumber,
          matchReason: 'Exact amount match',
          data: exp,
        });
      } else if (exp.referenceNumber && exp.referenceNumber === transaction.referenceNumber) {
        suggestions.push({
          id: exp.id,
         entityType: 'EXPENSE',
          entityId: exp.referenceNumber || exp.reimbursementNumber,
          matchReason: 'Reference number match',
          data: exp,
        });
      }
    });
  }
  return suggestions;
}
